import { useFormikContext } from 'formik';
import React, {FC} from 'react'
import { useLocale } from '../../../contexts/localeContext';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import CredentialDateInfo from '../credential-date-info';

interface Props {
    taskDescription: string;
    cardCode: string;
    deviceType: string;
    device: String | undefined;
    onBack: (event: any) => void;
}

const SummaryForm: FC<Props> = ({ taskDescription, cardCode, deviceType, device, onBack }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();

    return <div className="flex flex-col pt-3 pr-3 h-full relative">
        <div className="flex flex-row">
            <div className="flex flex-col flex-1">
                <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.taskDetails)}:</h2>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.task)}: <span className="text-sm text-black">{taskDescription}</span></h4>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.procedure)}: <span className="text-sm text-black">{deviceType}</span></h4>
            </div>
        </div> <div className="flex flex-row pt-3">
            <div className="flex flex-col flex-1">
                <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.enrolmentDetails)}:</h2>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.card)}: <span className="text-sm text-black">{cardCode}</span></h4>
                <CredentialDateInfo values={values} />
            </div>
        </div> 
        
        <div className="flex flex-row pt-3">
        {device !== undefined ?
            <div className="flex flex-col flex-1">
                <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.selectedDevice)}:</h2>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.device)}: <span className="text-sm text-black">{device}</span></h4>
            </div>
         : null}   
        </div>     

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="secondary secondary-inverse py-1 px-5 "
                    type="button"
                    onClick={(event) => onBack(event)}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type="submit">{translate.byKey(TranslationKeys.confirm)}</button>
            </div>
        </div>
    </div>
}

export default SummaryForm;
